/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_RefreshInputs */

const cs_addr_sugg_refresh = /** @type {(inputs: Addr_Sugg_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znovu dohledat v RÚIAN`)
};

const en_addr_sugg_refresh = /** @type {(inputs: Addr_Sugg_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Look up again in RÚIAN`)
};

/**
* | output |
* | --- |
* | "Look up again in RÚIAN" |
*
* @param {Addr_Sugg_RefreshInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_refresh = /** @type {((inputs?: Addr_Sugg_RefreshInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_RefreshInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_refresh(inputs)
	return cs_addr_sugg_refresh(inputs)
});